.promoContainer {
	@apply
	yst-w-full
	yst-mt-6
}

a.promoLink {
	@apply
	yst-text-2xl
	yst-flex
	yst-flex-col
	yst-justify-center
	yst-items-center
	yst-max-w-[420px]
	yst-mx-auto
	yst-font-bold
	yst-no-underline
	yst-text-white
	yst-rounded-lg
	yst-shadow-md
	yst-overflow-hidden
	yst-bg-cover
	yst-bg-center
	yst-bg-no-repeat;

	aspect-ratio: 420/161;
	line-height: 32px;

	&:hover {
		@apply yst-text-white;

		span img {
			transform: translateX(8px);
		}
	}

	&:active, &:visited, &:focus {
		@apply yst-text-white;
	}

	span {
		@apply
		yst-underline
		yst-text-amber-400
		yst-whitespace-nowrap;

		img {
			@apply
			yst-inline
			yst-align-middle
			yst-ml-2
			yst-transition-transform
			yst-duration-200
			yst-ease-in-out;

			margin-top: 4px !important;
			height: 14px;
			width: 18px !important;
		}
	}
}
